
class VariantImage {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._thumbnails = document.querySelectorAll('[data-thumbnail]')
        this._mainImage = document.querySelector('[data-main-image-wrapper] img')
        this._variantSelector = document.querySelector('select[name="id"]')
    }

    onInit () {
        if (this._variantSelector) {
            this._variantSelector.addEventListener('change', (e) => {
                this.checkThumbs(parseInt(e.currentTarget.value))
            })
        }
    }

    checkThumbs (variant) {
        if (variant && this._thumbnails.length > 0 && this._mainImage) {
            let src = this._mainImage.src
            let found = false
            let currentActive = null
            for (let thumb of this._thumbnails) {
                if (thumb.classList.contains('active')) {
                    currentActive = thumb
                }
                thumb.classList.remove('active')
                let data = JSON.parse(thumb.dataset.thumbnail)
                if (data) {
                    if (data.variants) {
                        if (data.variants.indexOf(variant) !== -1 && !found) {
                            src = data.imageUrl
                            found = true
                            thumb.classList.add('active')
                        }
                    }
                }
            }
            if (!found) {
                currentActive.classList.add('active')
            }
            if (src !== this._mainImage.src) { this._mainImage.src = src }
        }
    }
}

export default VariantImage



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VariantImage.js